import React, { PropsWithChildren } from 'react'
import classnames from 'classnames/bind'

import { RowDeprecated } from '@caudena/core/ui-kit'
import { Typography } from '@caudena/core/ui-kit'
import { Container } from '@caudena/core/ui-kit'
import { EnterKey } from '@caudena/core/ui-kit'
import { BaseLink } from '@caudena/core/Link'

import styles from './index.scss'

const cx = classnames.bind(styles)

interface BaseSearchCardProps {
  icon: React.ReactElement
  id: string | number
  href: string
  selected: boolean
}

const BaseSearchCard: React.FC<PropsWithChildren<BaseSearchCardProps>> = ({
  icon,
  id,
  href,
  selected,
  children,
}) => {
  const styledIcon = React.cloneElement(icon, {
    className: cx('Icon'),
  } as React.HTMLAttributes<HTMLElement>)

  return (
    <BaseLink to={href} className={cx('BaseSearchCard', { selected })}>
      <Container gap={[0.5, 1]}>
        <RowDeprecated gap={0.5}>
          {styledIcon}
          <Typography variant="body2" color="black">
            {id}
          </Typography>
          {children}
        </RowDeprecated>
      </Container>
      <EnterKey className={cx('EnterBlock')} />
    </BaseLink>
  )
}

export default BaseSearchCard
